import axios from 'axios';
import { URL_REGION_STATES } from '../constants/urls';

export const FETCH_STATES_BEGIN = 'FETCH_STATES_BEGIN';
export const FETCH_STATES_SUCCESS = 'FETCH_STATES_SUCCESS';
export const FETCH_STATES_FAILURE = 'FETCH_STATES_FAILURE';

export const fetchStates = () => async (dispatch) => {
  dispatch({ type: FETCH_STATES_BEGIN });

  try {
    const response = await axios.get(URL_REGION_STATES);

    dispatch({
      payload: response.data,
      type: FETCH_STATES_SUCCESS,
    });
  } catch (error) {
    dispatch({
      payload: error && error.response && error.response.statusText,
      type: FETCH_STATES_FAILURE,
    });
  }
};
